import { render, staticRenderFns } from "./compression-data.vue?vue&type=template&id=c814fa92&scoped=true"
import script from "./compression-data.vue?vue&type=script&lang=js"
export * from "./compression-data.vue?vue&type=script&lang=js"
import style0 from "./compression-data.vue?vue&type=style&index=0&id=c814fa92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c814fa92",
  null
  
)

export default component.exports